import DespesasRotas from "./despesas/DespesasRotas"
import PagamentosRotas from "./pagamento/PagamentosRotas"

export default {
    path: 'fornecedores',
    name: 'DespesasGerais_Fornecedores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [DespesasRotas, PagamentosRotas]
}